<div class="followed-producers-events-section">
  <div class="title-area">
    <h2>Próximos eventos de seus produtores favoritos</h2>
  </div>

  <div class="events-area">
    @if (events) {
      @for (event of events; track event.id) {
        <app-event-card [event]="event" [isProducerArea]="false" />
      } @empty {
        <p>Atualmente não existe nenhum evento futuro!</p>
      }
    } @else {
      <p-skeleton height="282px" />
      <p-skeleton height="282px" />
      <p-skeleton height="282px" />
      <p-skeleton height="282px" />
    }
  </div>
</div>
